// extracted by mini-css-extract-plugin
export var column = "footer-module--column--a4fd7";
export var columnInner = "footer-module--columnInner--65c81";
export var connect = "footer-module--connect--b36f3";
export var contentLabel = "footer-module--contentLabel--4d93a";
export var contentLink = "footer-module--contentLink--636ce";
export var footer = "footer-module--footer--03d8a";
export var general = "footer-module--general--c8c60";
export var landingPage = "footer-module--landingPage--64845";
export var landingPageCaption = "footer-module--landingPageCaption--473db";
export var landingPageImage = "footer-module--landingPageImage--6d41b";
export var landingPageIntro = "footer-module--landingPageIntro--08a52";
export var menu = "footer-module--menu--315f6";
export var menuItem = "footer-module--menuItem--2df8c";
export var menuSection = "footer-module--menuSection--9b57f";
export var menuSubscribe = "footer-module--menuSubscribe--6e790";
export var mobileFooter = "footer-module--mobileFooter--7e239";
export var mobileMenu = "footer-module--mobileMenu--62abe";
export var row = "footer-module--row--00182";
export var simple = "footer-module--simple--03642";
export var socialLink = "footer-module--socialLink--a11d8";
export var socialList = "footer-module--socialList--0adb5";